import React from 'react';
import Style from './Home.module.scss';
import me from '../../img/self.png';
import classNames from 'classnames';
import EmojiBullet from "./EmojiBullet";
import SocialIcon from "./SocialIcon";
import {Box} from "@mui/material";
import {info, getColors} from "../../info/Info";

export default function Home({innerRef, darkMode}) {

   const openresume = () => {
      window.open("https://drive.google.com/file/d/1rH4PyehYk2fQyyV_KlAw_O-fP-im9nXr/view?usp=sharing", "_blank");
   }

   return (
      <Box ref={innerRef} component={'main'} display={'flex'} flexDirection={{xs: 'column', md: 'row'}} alignItems={'center'}
           justifyContent={'center'} minHeight={'calc(100vh - 175px)'} id={'home'}>
         <Box className={classNames(Style.avatar, Style.shadowed)} alt={'image of developer'} style={{border: '3px solid black'}} component={'img'} src={me} width={{xs: '30vh', md: '35vh'}}
              height={{xs: '30vh', md: '35vh'}}
              borderRadius={'50%'} mb={{xs: '1.5rem', sm: 0}} mr={{xs: 0, md: '2.5rem'}}/>
         <Box>
            <h1>Hi, I'm <span style={{color: getColors(darkMode)[0]}}>{info.firstName}</span><span className={Style.hand}>🖊️</span>
            </h1>
            <h2>I'm {info.position}.</h2>
            <Box component={'ul'} p={'0.8rem'}>
               {info.miniBio.map((bio, index) => (
                  <EmojiBullet key={index} emoji={bio.emoji} text={bio.text}/>
               ))}
            </Box>

            <Box display={'flex'} gap={'1.5rem'} justifyContent={'center'} fontSize={{xs: '2rem', md: '2.5rem'}}>
              {/* <button className={Style.resumebutton} onClick={openresume}>
                <span style={{color: getColors(darkMode)[0]}}>Resume</span>
              </button> */}
              {info.socials.map((social, index) => (
                <SocialIcon key={index} link={social.link} icon={social.icon} label={social.label} />
              ))}
            </Box>
         </Box>
      </Box>
   )
}
